/**
 * Small status line under a rel-vol baseline setting (issue #593): "loading
 * baseline history…", history unavailable, forced time of day without enough
 * sessions ("time of day: 3/5 sessions, not enough history on 12 bars: no
 * markers there"), or auto running on the trailing mean. Nothing when the
 * baseline is fine or trailing is chosen.
 */
import React from 'react';
import { useMarketStore } from '../store/marketStore';
import { useVestVolumeStore } from '../store/vestVolumeStore';
import { useCmeBaselineHistoryStore } from '../store/cmeBaselineHistoryStore';
import { baselineHintText, useRelVolStatusStore } from '../store/relVolStatusStore';
import type { RelVolBaseline } from '../utils/relVolBaseline';

const BaselineHistoryHint: React.FC<{ venue: 'vest' | 'cme'; baseline: RelVolBaseline; style?: React.CSSProperties }> = ({ venue, baseline, style }) => {
  const symbol = useMarketStore((s) => s.symbol);
  const vestLoading = useVestVolumeStore((s) => s.historyLoading);
  const vestError = useVestVolumeStore((s) => s.error);
  const cme = useCmeBaselineHistoryStore((s) => (symbol ? s.bySymbol[symbol] : undefined));
  const summary = useRelVolStatusStore((s) => (venue === 'vest' ? s.vest : s.cme));
  const text = baselineHintText({
    baseline,
    loading: venue === 'vest' ? vestLoading : cme?.status === 'loading',
    error: venue === 'vest' ? vestError : cme?.status === 'error' ? cme.error : null,
    summary,
  });
  if (!text) return null;
  return (
    <div className="baseline-history-hint" data-testid={`${venue}-baseline-hint`} style={{ fontSize: 10, opacity: 0.75, fontStyle: 'italic', ...style }}>
      {text}
    </div>
  );
};

export default BaselineHistoryHint;
